import {
  exceptFilterKey,
  exceptFilterKeyBR,
  requestTypeMap,
  cityOptionsMap,
  cityValuesMap,
  CityAndAreaKeyMap,
} from './utils'
import { i18n, getBDCountry } from '@/common/utils/i18n'
import VueI18n from '@/i18n/locale'
import { showRtboStore, isSaaSBiz } from '@/common/utils/BizUtils'

export default {
  filterValues(state) {
    const currentTab = state.currentTab
    const filterValue = state.filterValue || {}
    const lists = state.lists || {}
    const params = { ...filterValue }

    // --- 特殊逻辑
    params.requestType = requestTypeMap[currentTab]
    params.pageNo = (lists[currentTab] || {}).pageNo || params.pageNo
    // params.pageSize = (lists[currentTab] || {}).pageSize || params.pageSize
    // --- 排除逻辑
    const country = getBDCountry() || 'MX'
    const exceptKey =
      (country === 'BR' ? exceptFilterKeyBR[currentTab] : exceptFilterKey[currentTab]) || []
    exceptKey.forEach(key => {
      delete params[key]
    })
    // start --- 城市参数特殊逻辑
    const keys = cityValuesMap[currentTab] || []
    for (const key in params) {
      if (keys.includes(key)) {
        params[CityAndAreaKeyMap[key]] = filterValue[key]
      }
    }
    delete params.AreaCityId
    delete params.AreaAreaIds
    // end --- 城市参数特殊逻辑
    return params
  },
  MoreFilterOption(state) {
    const currentTab = state.currentTab
    const filterOptions = state.filterOptions || {}

    const selectorsSSL = [
      {
        label: VueI18n.t('FoodB_list_Name_of_dxYm' /** 销售姓名 */),
        key: 'notMyStore',
        col: 1,
        multiple: false,
        options: filterOptions.notMyStore,
      },
      {
        label: VueI18n.t('Gattaran_status_jQaO_nxvn' /** 跟进状态 */),
        key: 'followUpStatus',
        col: 2,
        options: filterOptions.followUpStatusOptions,
      },
      {
        label: i18n.gettext('签约状态'),
        key: 'status',
        col: 2,
        options: filterOptions.status.map(item => ({
          ...item,
          label: item.label,
          /**
          label:
            currentTab === TabNames.my.key
              ? `${item.label}(${item.count || 0})`
              : item.label
         */
        })),
      },
      {
        label: VueI18n.t('Gattaran_status_jQaO_nxvn' /** 跟进状态 */),
        key: 'sslFollowUpStatus',
        col: 2,
        options: filterOptions.sslFollowUpStatus,
      },
      {
        label: VueI18n.t('Gattaran_V20__eJGq' /** 商机等级 */),
        key: 'potential',
        col: 3,
        options: filterOptions.potential,
      },
      {
        label: VueI18n.t('Gattaran_V20__THMR' /** 商户等级 */),
        key: 'rPerformance',
        col: 3,
        options: filterOptions.rPerformance,
      },
      {
        label: VueI18n.t('FoodB_Commision_Type_of_EIWZ' /** 商户类型 */),
        key: 'type',
        col: 3,
        options: filterOptions.type,
      },
      {
        label: i18n.gettext('经营状态'),
        key: 'bizStatus',
        col: 1,
        options: filterOptions.bizStatus,
      },
      {
        label: VueI18n.t('FoodD_Storefront_YFcS_cnUy' /** Storefront */),
        key: 'storeFrontStatus',
        col: 3,
        multiple: false,
        options: filterOptions.storeFrontStatus,
      },
      {
        label: 'Priority',
        key: 'priority',
        col: 2,
        options: filterOptions.priority,
      },
    ]
    const selectorsBR = [
      {
        label: VueI18n.t('FoodB_list_Name_of_dxYm' /** 销售姓名 */),
        key: 'notMyStore',
        col: 1,
        multiple: false,
        options: filterOptions.notMyStore,
      },
      {
        label: VueI18n.t('Gattaran_status_jQaO_nxvn' /** 跟进状态 */),
        key: 'followUpStatus',
        col: 2,
        options: filterOptions.brFollowUpStatus,
      },
      {
        label: i18n.gettext('经营状态'),
        key: 'bizStatus',
        col: 1,
        options: filterOptions.bizStatus,
      },
      {
        label: VueI18n.t('FoodB_Commision_Type_of_EIWZ' /** 商户类型 */),
        key: 'type',
        col: 3,
        options: filterOptions.type,
      },
      {
        label: VueI18n.t('Gattaran_V20__eJGq' /** 商机等级 */),
        key: 'potential',
        col: 3,
        options: filterOptions.potential,
      },
      {
        label: VueI18n.t('Gattaran_opt_aDBh_QgeX' /** 开店检查项 (RTBO) */),
        key: 'openCheck',
        multiple: false,
        col: 2,
        options: filterOptions.openCheck,
      },
      {
        label: VueI18n.t('Gattaran_selection_TfHc_eCVN' /** 未完成的上线检查项 */),
        key: 'openCheckInfo',
        col: 2,
        options: filterOptions.openCheckInfo,
      },
      {
        label: VueI18n.t('FoodB_management_Exlz_JjpO' /** 是否存在待发放物料 */),
        key: 'hasPendingGrantMaterial', // 明确表示"有待发放物料"
        col: 1,
        multiple: false,
        options: filterOptions.hasPendingGrantMaterial,
      },
      {
        label: VueI18n.t('FoodB_SimbaSignup0331_qKdR_ELgg' /** 商机来源 */),
        key: 'source',
        col: 2,
        options: filterOptions.source,
      },
      {
        label: VueI18n.t('FoodB_opencheck_UtkB_sIJi' /** 是否完成二次检查 */),
        key: 'bdOpenCheckStatus',
        multiple: false,
        col: 2,
        options: filterOptions.bdOpenCheck,
      },
    ]
    const country = getBDCountry() || 'MX'
    const exceptKey =
      (country === 'BR' ? exceptFilterKeyBR[currentTab] : exceptFilterKey[currentTab]) || []

    const selectors = showRtboStore() || isSaaSBiz() ? selectorsBR : selectorsSSL
    return selectors.filter(item => {
      return !exceptKey.includes(item.key)
    })
  },
  currentListItems(state) {
    const currentTab = state.currentTab
    const lists = state.lists || {}
    return lists[currentTab] || { data: [], total: 0, pageNo: 1, pageSize: 20 }
  },

  citiesOptions(state) {
    const currentTab = state.currentTab
    const filterOptions = state.filterOptions || {}
    return filterOptions[cityOptionsMap[currentTab]]
  },
}
